import Component from './Component';
import ComponentStyles from './Styles';

export const Styles = ComponentStyles;
export const { BadgeGroup } = Styles;

export default Component;
